export default function random(min, max, rounded) {
    const value = Math.random() * (max - min) + min;
    return typeof rounded === 'undefined' || rounded ? Math.floor(value) : value;
}
